<template>
  	<div class="animated fadeIn bgV2">
    	<b-row>
      		<b-col md="12">
        		<gofix-tab
            		class="mt-3 ContractCaseSettings"
            		:data="contract_tab"
					:query-param="{id:$route.params.id}"
					activeKey="emails"
            		arrows >
          			<template slot="gofixTab:emails">
						<gofix-card classContent="mb-0" title=" ">
							<b-row align-v="center">
								<b-col md="6">
									<gofix-form-dropdown
										label="Email To"
										v-model="project_department_head_emails"
										:options="[]"
										:filterable="false"
										taggable
										pushTags
										multiple
										noDrop>
									</gofix-form-dropdown>
								</b-col>
								<b-col md="6" class="text-right">
									<gofix-button @click="saveData" :loading="loadingSave" label="Save"></gofix-button>
								</b-col>
							</b-row>
						</gofix-card>
          			</template>
        		</gofix-tab>
      		</b-col>
    	</b-row>
	</div>
</template>
<script>
import tabData from '@/data/_tabs';
import { mapGetters, mapActions } from 'vuex';

export default {
  	name: 'contract-maintenance-settings',
  	data () {
    	return {
			contract_tab: tabData.safety_projects,
			project_department_head_emails: [],
			loadingSave: false,
			timer: null
		}
	},
	components: {
		
	},
  	created() {
		if(!this.SContract || !this.SContract.id) {
			this.$store.dispatch( 'ContractController/getSContract', this.$route.params.id)
				.catch(error => { this.$router.push(`/v2/safety-app-project`) })
		} else {
			if(this.SContract.project_department_head_emails) {
				this.project_department_head_emails = this.SContract.project_department_head_emails;
			}
		}
	},
 	filters: {
		
	},
  	watch: {
		SContract: function(val) {
			console.log(val);
			if(val && val.project_department_head_emails) {
				this.project_department_head_emails = val.project_department_head_emails;
			} else {
				this.project_department_head_emails = [];
			}
        }
  	},
  	computed: {
            ...mapGetters({
                SContract: 'ContractController/SContract',
            }),
        },
  	methods: {
		emailValidationCheckFormat(email_address){
            if(email_address && email_address != ''){
                let pattern = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
                let result = pattern.test(email_address);
                return result;
            }
            return true;
        },
		saveData() {
			if (this.timer) {
                    clearTimeout(this.timer);
                    this.timer = null;
                }
                this.timer = setTimeout(async () => {
					let filters = this.project_department_head_emails.filter(item => {
						if(!this.emailValidationCheckFormat(item)) return item
					})
					if(filters.length) return this.$alertNotification('Invalid email', 'danger');
                    this.loadingSave = true;
                    let objClone = {
                        contract_id: this.SContract.id,
                        client_id: this.SContract.client_id,
                        supplier_id: this.SContract.supplier_id,
                        contract_name: this.SContract.contract_name,
                        abbreviation: this.SContract.abbreviation,
                        description: this.SContract.description,
                        deposit_amount: this.SContract.deposit_amount,
                        issuing_bank: this.SContract.issuing_bank,
                        deposit_expiry: this.SContract.deposit_expiry,
                        insurance_expiry: this.SContract.insurance_expiry,
                        insurance_excess: this.SContract.insurance_excess,
                        insurance_type: this.SContract.insurance_type,
                        timezone: this.SContract.timezone,
						settings: this.SContract.settings,
                        case_settings: this.SContract.case_settings,
						maintenance_settings: this.SContract.maintenance_settings,
						project_department_head_emails: this.project_department_head_emails
                    }

                    objClone.settings = JSON.stringify(objClone.settings);
                    objClone.case_settings = JSON.stringify(objClone.case_settings);
					objClone.maintenance_settings = JSON.stringify(objClone.maintenance_settings);
					console.log(objClone);
                    this.$store.dispatch('ContractController/UpdateSupllierContract', objClone)
                    .then(response => {
                        this.loadingSave = false;
                        this.$store.dispatch('ContractController/getClientContractID', objClone.contract_id);
                        this.$alertNotification(this.$notificationV2('editing', 'client_contract_setting'));
                    })
                    .catch(error => {
                        this.loadingSave = false;
                    });
                }, 100);
		}
	},
}
</script>
